const prefix = '@dashboard/sitesLowStock';

export const SET_SITE = `${prefix}/SET_SITE`;
